import React from 'react'

const PersonalComputer = (props) => (
  <svg viewBox="0 0 45 45" {...props}>
    <defs>
      <clipPath id="a">
        <path d="M0 36h36V0H0v36z" />
      </clipPath>
      <clipPath id="b">
        <path d="M4 8.912c-1.105 0-1.667-1.004-2-2.008L0 2.009C0 .899.895 0 2 0h32c1.105 0 2 .899 2 2.009l-2 4.895c-.417.963-.895 2.008-2 2.008H4z" />
      </clipPath>
      <clipPath id="c">
        <path d="M0 36h36V0H0v36z" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" transform="matrix(1.25 0 0 -1.25 0 45)">
      <path
        d="M33 10.92a2.004 2.004 0 0 0-2-2.007H5c-1.104 0-2 .899-2 2.008v17.07C3 29.102 3.896 30 5 30h26c1.105 0 2-.9 2-2.008V10.92zm3-8.912A2.004 2.004 0 0 0 34 0H2C.896 0 0 .9 0 2.008l2 4.895c.333 1.005.896 2.01 2 2.01h28c1.105 0 1.583-1.047 2-2.01l2-4.895z"
        fill="#ccd6dd"
      />
    </g>
    <g clipPath="url(#b)" transform="matrix(1.25 0 0 -1.25 0 45)">
      <path d="M38 1.925H0l1-4.059h37v4.059z" fill="#9aaab4" />
    </g>
    <g clipPath="url(#c)" transform="matrix(1.25 0 0 -1.25 0 45)">
      <path
        d="M31 11.925c0-.555-.447-1.004-1-1.004H6c-.552 0-1 .449-1 1.004v15.063c0 .554.448 1.004 1 1.004h24c.553 0 1-.45 1-1.004V11.925z"
        fill="#5dadec"
      />

      <path
        d="M32.906 4.958l-.76 2.175c-.239.46-.635.838-1.187.838H5.11c-.552 0-.906-.408-1.156-1.036l-.688-1.977c-.218-.596.448-1.004 1-1.004h7.578s.937.047 1.103.608c.192.648.415 1.624.463 1.795.074.264.388.531.856.531h8.577c.5 0 .747-.253.811-.566.042-.204.313-1.14.438-1.782.111-.57 1.22-.586 1.22-.586h6.594c.553 0 1.22.471 1 1.004"
        fill="#aebbc1"
      />

      <path
        d="M22.375 2.887h-7.781c-.375 0-.538.343-.485.675.054.331.36 1.792.383 1.963.024.171.275.375.524.375h7.015c.297 0 .49-.163.55-.49.06-.326.302-1.64.321-1.94.02-.301-.168-.583-.527-.583"
        fill="#9aaab4"
      />
    </g>
  </svg>
)

export default PersonalComputer
